/* ==========================================================================
   FlatWine — a11y.js
   La trampa de foco de los tres paneles a pantalla completa: el cajón del
   carrito, el del menú y el del buscador.

   Estaba escrita tres veces y ya se había desviado en tres direcciones, que
   es justo el argumento que format.js dejó escrito para vivir aparte: «el PDP
   y el carrito lo necesitan igual, y duplicarlo garantiza que se
   desincronicen».

   Lo que se había desviado:
     - menu.js filtraba los input[type=hidden] del selector; cart.js no. Hoy
       cart.js acierta por casualidad —el único input oculto del tema vive en
       el buscador predictivo, que nunca se renderiza dentro del cajón del
       carrito—, y el día que alguien meta un formulario ahí, la trampa tendrá
       un primero o un último muerto y nadie lo relacionará con esta línea.
     - menu.js recorría el DOM en crudo, sin descartar lo oculto ni lo inerte.
     - la rama de «el foco no está dentro del panel» llegó tarde a menu.js,
       después de que se descubriera que sin ella Tab se escapaba al logotipo
       de detrás del velo.

   Aquí vive SOLO la recolección de elementos y el ciclo del Tab. Lo que
   decide cuándo la trampa está activa se queda en cada archivo, porque los
   tres lo deciden distinto: el buscador por ancho de pantalla, el carrito por
   su propio estado de apertura, el menú por una clase. Y los manejadores de
   Escape tampoco se tocan: el buscador cede el turno al listbox solo si el
   foco está en el campo, el menú cede siempre que haya sugerencias abiertas,
   y el carrito cierra sin más.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = 'a[href], button:not([disabled]), input:not([type="hidden"]), ' +
                 'select, textarea, [tabindex]:not([tabindex="-1"])';

  function enfocables(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll(SELECTOR)).filter(function (el) {
      return !el.hidden &&
             el.getAttribute('aria-hidden') !== 'true' &&
             !el.closest('[hidden], [inert]');
    });
  }

  /* Devuelve true si consumió el evento. Quien llama ya decidió que la trampa
     debe estar activa; aquí solo se cierra el ciclo. */
  function atrapar(root, event) {
    if (!root || event.key !== 'Tab') return false;
    var items = enfocables(root);
    if (!items.length) return false;

    var primero = items[0];
    var ultimo = items[items.length - 1];

    /* Sin esta rama, en cuanto se toca una zona no enfocable del panel el
       activeElement pasa a ser <body>, que no coincide ni con el primero ni
       con el último: no había preventDefault y el siguiente Tab llevaba el
       foco al contenido de detrás, visualmente tapado pero tabulable. */
    if (!root.contains(document.activeElement)) {
      event.preventDefault();
      primero.focus();
      return true;
    }
    if (event.shiftKey && document.activeElement === primero) {
      event.preventDefault();
      ultimo.focus();
      return true;
    }
    if (!event.shiftKey && document.activeElement === ultimo) {
      event.preventDefault();
      primero.focus();
      return true;
    }
    return false;
  }

  window.fwFocusTrap = { enfocables: enfocables, atrapar: atrapar };
})();
